import {get,post} from '@/util/http';
import { Notification } from 'uiv'

const news = {
    state:{
        newest: [],
        pic: [], 
        board: [],
        media: [],
        xmsite: [],
        volunteer: [],
        indexSlide: [],
    },
    mutations:{
        newestList(state, action){//最新动态
            state.newest = action
        },
        picList(state,action){//图片新闻
            state.pic = action
        },
        volunteerList(state,action){//志愿者风采
            state.volunteer = action
        },
    },
    actions:{
        async find({commit}, params){
            //params.type  0：最新动态，1：图片新闻，2：公告板，3：媒体报道,4：厦门动态，5：志愿者风采，6:新闻素材下载专区，7：会议动态，8：项目对接公告板，9：展商风采
            const res = await get('/CifitSystem/api/news/cifitNews/find.jhtml',params);
            if(res.code == 200){
                switch(params.type){
                    case 0:
                        commit('newestList',res.data)
                        break;
                    case 1:
                        commit('picList',res.data)
                        break;
                    case 5:
                        commit('volunteerList',res.data)
                        break;
                    default:
                        return res.data
                }
                // commit('latestSlideList',res.data)
                
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
        async findimgnews({commit}, params){
            const res = await get('/CifitSystem/api/news/cifitNews/findimgnews.jhtml',params);
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
        async newsinfo({}, params){
            const res = await get('/CifitSystem/api/news/cifitNews/newsinfo.jhtml',params);
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
        async newspage({}, params){
            const res = await get('/CifitSystem/api/news/cifitNews/newspage.jhtml',params);
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
    }
}

export default news


// WEBPACK FOOTER //
// ./src/store/modules/news.js